module.exports = __webpack_public_path__ + "static/img/gzh.6d85aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/gzh.png
// module id = xMFb
// module chunks = 1